const defaultContext = ['mainCookie', 'abTests'];
const trackers = {
  structured: 'trackStructEvent',
  selfDescribing: 'trackSelfDescribingEvent',
};

export const satisfactionFeedbackEntityDisplay = (category) => ({
  tracker: trackers.structured,
  data: {
    category,
    action: 'display',
    label: 'serp_page',
  },
  context: defaultContext,
});

export const satisfactionFeedbackEntityDismiss = (category) => ({
  tracker: trackers.structured,
  data: {
    category,
    action: 'dismiss',
    label: '',
    property: '',
  },
  context: defaultContext,
});

export const satisfactionFeedbackEntityScoreClick = (value, category) => ({
  tracker: trackers.structured,
  data: {
    category,
    action: 'click',
    label: 'score',
    property: '',
    value,
  },
  context: defaultContext,
});

export const satisfactionFeedbackEntitySubmit = (value, text, category) => ({
  tracker: trackers.structured,
  data: {
    category,
    action: 'click',
    label: 'submit_feedback',
    property: text,
    value,
  },
  context: defaultContext,
});
